/* ============================================================
   MUHRA — SIZE STRIP JS FINAL
   File: assets/muhra-size-strip.js
   Handles size chart popup only.
   All measurements render server-side — zero JS needed.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var overlay = document.getElementById('muhra-chart-overlay');
    if (!overlay || overlay._init) return;
    overlay._init = true;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-muhra-chart]');
      if (!t) return;
      e.preventDefault();
      var img = document.getElementById('muhra-chart-img');
      if (img) img.src = t.dataset.muhraChart;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    var btn = overlay.querySelector('.muhra-chart-popup__close');
    if (btn) btn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();